import { yup } from '@framework/validation/initYup.ts';
import { fromPairs } from 'lodash';
import {
  EngineInternalFieldSuffix,
  EngineInternalMetaKey,
} from '../../schema/expressions/EngineInternalFieldSuffix.ts';
import { type IEngineSection } from '../../schema/sections/IEngineSection.ts';

/**
 * Chiave statica all'interno dei `formValues` in cui manteniamo i valori
 * di stato delle sezioni.
 * È marcato come `EngineInternal` perché non deve essere serializzato come
 * parte dei valori.
 */
export const SectionsStatusKey = `__sectionsStatus${EngineInternalFieldSuffix}`;

export interface IEngineSectionStatus {
  /** Sezione aperta */
  opened: boolean;
  /** Inviato almeno una volta, fino all'ultima pagina */
  touched: boolean;
}

export function createSectionsStatusSchema(sections: IEngineSection[]) {
  return {
    [SectionsStatusKey]: yup
      .object(
        fromPairs(
          sections.map((section, i) => [
            section.id,
            createSectionStatusSchema(section, i),
          ]),
        ),
      )
      .meta({ [EngineInternalMetaKey]: true })
      .addChildrenParentDeps()
      .noUnknown(),
  };
}

function createSectionStatusSchema(
  section: IEngineSection,
  index: number,
): yup.ObjectSchema<IEngineSectionStatus> {
  const schema = yup
    .object({
      opened: yup.boolean().default(false),
      /**
       * Questo flag è impostato a `true` solo se la sezione è stata compilata
       * almeno una volta, fino all'ultima pagina.
       */
      touched: yup.boolean().default(false).meta({ step: index }),
      // Il messaggio di errore viene utilizzato in fase di riepilogo.
      // Fa in modo che il modulo non possa essere inviato se
      // tutte le sezioni non sono state compilate almeno una volta con
      // il "Salva e procedi"
      // NB Al momento per frawemork procedimenti questa funzionalità non
      // è attiva e non viene utilizzata in quanto le sezioni sono tutte mostrate
      // contestualmente nella stessa pagina.
      // .when([`$${VALIDATION_TYPE}`], ([validationType], schema) => {
      //   if (validationType !== ValidationType.COMPLETE) return schema;
      //   return schema.oneOf([true], `La sezione non è stata compilata`);
      // }),
    })
    .noUnknown();

  /**
   * In caso la sezione non sia visibile o compilabile, eliminiamo l'intero
   * oggetto dallo schema.
   */
  const version = section.ultimaVersione;

  /**
   * SU FWP la visibilità dello schema non è gestita tramite il sectionStatus@internal,
   * a differenza del precedente dove le sezioni non avevano un oggetto nel validatore e quindi
   * era necessario salvarsi le informazioni di visibilità all'interno di questo oggetto.
   */
  // schema = setSectionVisibleOrEnabledCondition(schema, version?.visibile);
  // schema = setSectionVisibleOrEnabledCondition(schema, version?.compilabile);

  return schema;
}
